import { render, staticRenderFns } from "./Photos.vue?vue&type=template&id=31210cea&scoped=true"
import script from "./Photos.vue?vue&type=script&lang=js"
export * from "./Photos.vue?vue&type=script&lang=js"
import style0 from "./Photos.vue?vue&type=style&index=0&id=31210cea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31210cea",
  null
  
)

export default component.exports